import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: ':id', redirectTo: 'app/login/:id' }, //, pathMatch: 'full'
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'app/login/:id',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },

  // {
  //   path:'tab1',
  //   loadComponent: () =>import('./tab1/tab1.page').then(m=>m.Tab1Page)
  //  },
  //  {
  //   path:'tab2',
  //   loadComponent: () =>import('./tab2/tab2.page').then(m=>m.Tab2Page)
  // },
  // {
  //   path:'tab3',
  //   loadComponent: () =>import('./tab3/tab3.page').then(m=>m.Tab3Page)
  // },
  {
    path: 'app/selectvideo',
    loadComponent: () =>
      import('./selectvideo/selectvideo.page').then((m) => m.SelectVideoPage),
  },
  {
    path: 'app/admin',
    loadComponent: () => import('./admin/admin.page').then((m) => m.AdminPage),
  },
  {
    path: 'app/users',
    loadComponent: () => import('./users/users.page').then((m) => m.UsersPage),
  },
  {
    path: 'app/user',
    loadComponent: () => import('./user/user.page').then((m) => m.UserPage),
  },
  {
    path: 'app/signup',
    loadComponent: () =>
      import('./signup/signup.page').then((m) => m.SignupPage),
  },
  {
    path: 'app/forgot',
    loadComponent: () =>
      import('./forgot/forgot.page').then((m) => m.ForgotPage),
  },
  {
    path: 'app/translate',
    loadComponent: () =>
      import('./translate/translate.page').then((m) => m.TranslatePage),
  },
  {
    path: 'app/about',
    loadComponent: () => import('./about/about.page').then((m) => m.AboutPage),
  },
  {
    path: 'app/selectpic',
    loadComponent: () =>
      import('./selectpic/selectpic.page').then((m) => m.SelectpicPage),
  },
  {
    path: 'app/team',
    loadComponent: () => import('./team/team.page').then((m) => m.TeamPage),
  },
  {
    path: 'app/clubs',
    loadComponent: () => import('./clubs/clubs.page').then((m) => m.ClubsPage),
  },
  {
    path: 'app/chalenges',
    loadComponent: () =>
      import('./chalenges/chalenges.page').then((m) => m.ChalengesPage),
  },
  {
    path: 'app/chalengesettings',
    loadComponent: () =>
      import('./chalengesettings/chalengesettings.page').then(
        (m) => m.ChalengesettingsPage
      ),
  },
  {
    path: 'app/results',
    loadComponent: () =>
      import('./results/results.page').then((m) => m.ResultsPage),
  },
  {
    path: 'app/teamchallenges',
    loadComponent: () =>
      import('./teamchallenges/teamchallenges.page').then(
        (m) => m.TeamchallengesPage
      ),
  },
  {
    path: 'app/calculator',
    loadComponent: () =>
      import('./calculator/calculator.page').then((m) => m.CalculatorPage),
  },
  {
    path: 'app/edit-player',
    loadComponent: () =>
      import('./edit-player/edit-player.page').then((m) => m.EditPlayerPage),
  },
  {
    path: 'app/edit-team',
    loadComponent: () =>
      import('./edit-team/edit-team.page').then((m) => m.EditTeamPage),
  },
  {
    path: 'app/edit-club',
    loadComponent: () =>
      import('./edit-club/edit-club.page').then((m) => m.EditClubPage),
  },
  {
    path: 'app/lineup',
    loadComponent: () =>
      import('./lineup/lineup.page').then((m) => m.LineupPage),
  },
  {
    path: 'app/share',
    loadComponent: () => import('./share/share.page').then((m) => m.SharePage),
  },
  {
    path: 'app/post',
    loadComponent: () => import('./post/post.page').then((m) => m.PostPage),
  },
  {
    path: 'app/calendar',
    loadComponent: () =>
      import('./calendar/calendar.page').then((m) => m.CalendarPage),
  },
  {
    path: 'app/privacy',
    loadComponent: () =>
      import('./privacy/privacy.page').then((m) => m.PrivacyPage),
  },
  {
    path: 'app/message',
    loadComponent: () =>
      import('./message/message.page').then((m) => m.MessagePage),
  },
];
